import React from "react";
import PageHead from "../../Head";

import Context from "@/context/Context";
import SignIn from "@/components/sign/SignIn";
import Header from "@/components/Header/Header";
import PopupMobileMenu from "@/components/Header/PopupMobileMenu";

const SigninPage = () => {

  return (
    <>
      <PageHead title="Sign In" />

      <main className="page-wrapper">
        <Context>
          <Header
            headerTransparent="header-transparent"
            headerSticky="header-sticky"
            btnClass="btn-small round"
          />
          <PopupMobileMenu />
          <SignIn />
        </Context>
      </main>
    </>
  );
};

export default SigninPage;
